import { render, staticRenderFns } from "./AccessControlCard.vue?vue&type=template&id=9ad0b968&scoped=true&lang=html&"
import script from "./AccessControlCard.vue?vue&type=script&lang=js&"
export * from "./AccessControlCard.vue?vue&type=script&lang=js&"
import style0 from "./AccessControlCard.vue?vue&type=style&index=0&id=9ad0b968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad0b968",
  null
  
)

export default component.exports